import { render, staticRenderFns } from "./Findings.vue?vue&type=template&id=3b4e3867&scoped=true&"
import script from "./Findings.vue?vue&type=script&lang=js&"
export * from "./Findings.vue?vue&type=script&lang=js&"
import style0 from "./Findings.vue?vue&type=style&index=0&id=3b4e3867&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e3867",
  null
  
)

export default component.exports